import { sample, sampleSize, random, min } from 'lodash';
import { arrToStr } from 'utils/string';

const types = {
  Stationary: 'stationary',
  Transport: 'transport',
};
const scheduleInterval = 60000;
const dismissInterval = 3500;
const updatesLimit = 10;

let timeout;

function createUpdate(id, text, type) {
  return {
    id,
    text,
    type,
  };
}

const state = {
  active: false,
  updates: [],
};

const mutations = {
  addUpdate(state, update) {
    state.updates = [...state.updates, update];
  },
  removeUpdate(state, id) {
    state.updates = state.updates.filter(update => update.id !== id);
  },
  activate(state) {
    state.active = true;
  },
  deactivate(state) {
    state.active = false;
  },
};

const actions = {
  scheduleUpdates: ({ commit, dispatch, state, rootState }) => {
    if (!state.active) {
      commit('activate');
    }

    const { users } = rootState.audience;
    const usersLength = users.length;
    const updatesSize = Math.round(usersLength / 10);
    const usersWithUpdates = sampleSize(
      users,
      min([updatesSize, updatesLimit])
    );

    usersWithUpdates.forEach(user => {
      const { id, _presentEventType, _presentEvents, _presentMoments } = user;
      const text = arrToStr([..._presentEvents, sample(_presentMoments)]);

      if (text.length === 0) {
        return;
      }

      const delay = random(scheduleInterval);

      setTimeout(
        () =>
          commit('addUpdate', createUpdate(id, text, types[_presentEventType])),
        delay
      );
      setTimeout(() => commit('removeUpdate', id), delay + dismissInterval);
    });

    timeout = setTimeout(() => dispatch('scheduleUpdates'), scheduleInterval);
  },
  deactivate: ({ commit }) => {
    if (timeout) {
      clearTimeout(timeout);
    }

    commit('deactivate');
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
